import {
  NgClass,
  NgFor,
  NgIf,
  NgOptimizedImage,
  NgStyle,
} from '@angular/common';
import { Component, Input, OnChanges, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { Product } from 'src/app/classes/utility';
import { CarouselComponent } from 'src/app/components/carousel/carousel.component';
import { ProductService } from '../../product.service';

@Component({
    selector: 'app-image-carousel',
    imports: [CarouselComponent, NgIf, NgOptimizedImage, NgFor, NgStyle, NgClass],
    templateUrl: './image-carousel.component.html',
    styleUrl: './image-carousel.component.scss'
})
export class ImageCarouselComponent implements OnChanges, OnInit, AfterViewInit {
  @Input() product!: Product;
  @ViewChild(CarouselComponent) carousel!: CarouselComponent;
  options = {
    0: { slides: 1, nav: false },
  };
  _scrollTo = 0;
  _sleeve: any | undefined;
  currentIndex = 0;

  constructor(private productService: ProductService) {
    this.productService.sleeveObservable.subscribe((data) => {
      this._sleeve = data;
    });
  }

  ngOnInit(): void {
    this.productService.variantObservable.subscribe((data) => {
      if (data && data.image_id) {
        const imageIndex = this.product.images.findIndex(
          (img) => img.id === data.image_id
        );
        if (imageIndex !== -1) {
          setTimeout(() => {
            this.scrollTo(imageIndex);
          }, 100);
        }
      }
    });
  }

  ngAfterViewInit(): void {
    if (this.carousel && this.carousel.slider) {
      this.carousel.slider.nativeElement.addEventListener('scroll', () => {
        this.updateCurrentIndex();
      });
    }
  }

  private updateCurrentIndex(): void {
    if (!this.carousel || !this.carousel.slider) return;
    
    const slider = this.carousel.slider.nativeElement;
    const slideWidth = slider.getBoundingClientRect().width;
    const scrollLeft = slider.scrollLeft;
    
    this.currentIndex = Math.round(scrollLeft / slideWidth);
  }

  ngOnChanges() {
    this._scrollTo = 0;
  }

  scrollTo(i: number) {
    this._scrollTo = structuredClone(i);
    this.currentIndex = i;
  }
}
